var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComputerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.928 8.327h1.959v28.47c0 .5.43.918.98.918H43.05v1.959H3.866c-1.616 0-2.938-1.281-2.938-2.878V8.327zm32.19 37.224h4.055v1.96h-23.51v-1.96h4.006l1.92-6.857 1.86.62-1.75 6.237h11.385l-1.748-6.238 1.858-.619 1.923 6.857zM2.886 4.41h30.367v1.959H.928V.49h47.02v36.295a2.894 2.894 0 01-2.897 2.889h-2.857v-1.96h2.857c.52 0 .939-.417.939-.929V2.45H2.888v1.96h-.001z",
    fill: "#0073F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.173 6.367a.98.98 0 100-1.958.98.98 0 000 1.958zm2.938 0a.98.98 0 100-1.959.98.98 0 000 1.96zm2.94 0a.98.98 0 100-1.959.98.98 0 000 1.96zM5.825 11.265V9.306H17.58v1.96H5.826zm0 3.919v-1.96h5.877v1.96H5.826zm0 3.918v-1.96H17.58v1.96H5.826zm0 3.918v-1.959h8.816v1.96H5.826z",
    fill: "#0073F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.805 26.94H20.52v5.877H6.805v-5.878 0z",
    stroke: "#0073F7",
    strokeWidth: 1.959
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.724 15.184a1.47 1.47 0 100-2.939 1.47 1.47 0 000 2.939z",
    fill: "#0073F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.295 20.788l-1.599-.532a1.958 1.958 0 01-1.34-1.86v-7.13a1.96 1.96 0 011.96-1.96h8.816a1.959 1.959 0 011.959 1.96v7.072a1.958 1.958 0 01-1.484 1.9l-3.176.794-.476-1.9 3.177-.794v-7.072h-8.817v7.131l2.94.98v11.075l.979.98.767-.767-.882-1.767.98-1.959-.98-1.959 1.198-2.397 1.752.876-.76 1.521.98 1.96-.98 1.958 1.077 2.153-3.152 3.151-2.939-2.939V20.787z",
    fill: "#0073F7"
  })));
}

export default SvgComputerIcon;